import { Component } from '@angular/core';
import { GoBackComponent } from 'shared/components/go-back/go-back.component';
import { TranslateModule } from '@ngx-translate/core';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-family-card-health',
  templateUrl: './family-card-health.component.html',
  styleUrl: './family-card-health.component.scss',
  standalone: true,
  imports: [GoBackComponent, TranslateModule, KorviuButtonComponent]
})
export class FamilyCardHealthComponent {
  public familyCardHealth: any = {
    title: 'okeeyCash.familyCardHealth.title',
    subTitle: 'okeeyCash.familyCardHealth.subTitle',
    link: 'https://usa.okeeycash.com/assets/documents/DDAform.pdf',
    details: 'okeeyCash.familyCardHealth.details',
    illustration: 'assets/img/my-okeey-cash/family-card-health/illustration.svg',
    illustrationMobile: 'assets/img/my-okeey-cash/family-card-health/illustration-mobile.svg',
    learnMore: 'okeeyCash.familyCardHealth.learnMore'
  };

  public learnMore(): void {
    window.open('https://www.familycardservices.com/', '_blank');
  }
}
